module.exports = __webpack_public_path__ + "media/svg-new/facebook 4-8a790ee3.svg";